var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaude(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0593 2.88066C22.0593 2.4961 21.9065 2.12729 21.6346 1.85536C21.3627 1.58343 20.9938 1.43066 20.6093 1.43066H11.9093C11.5247 1.43066 11.1559 1.58343 10.884 1.85536C10.612 2.12729 10.4593 2.4961 10.4593 2.88066V10.1307H3.20928C2.82471 10.1307 2.4559 10.2834 2.18397 10.5554C1.91204 10.8273 1.75928 11.1961 1.75928 11.5807V20.2807C1.75928 20.6652 1.91204 21.034 2.18397 21.306C2.4559 21.5779 2.82471 21.7307 3.20928 21.7307H10.4593V28.9807C10.4593 29.3652 10.612 29.734 10.884 30.006C11.1559 30.2779 11.5247 30.4307 11.9093 30.4307H20.6093C20.9938 30.4307 21.3627 30.2779 21.6346 30.006C21.9065 29.734 22.0593 29.3652 22.0593 28.9807V21.7307H29.3093C29.6938 21.7307 30.0627 21.5779 30.3346 21.306C30.6065 21.034 30.7593 20.6652 30.7593 20.2807V11.5807C30.7593 11.1961 30.6065 10.8273 30.3346 10.5554C30.0627 10.2834 29.6938 10.1307 29.3093 10.1307H22.0593V2.88066Z",
    stroke: "#001574",
    strokeWidth: 1.72102,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaude);
export default __webpack_public_path__ + "static/media/saude.96b54717e94ff22eeed2ecd64a19820b.svg";
export { ForwardRef as ReactComponent };